import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormValidatorService } from '@shared/services/forms/form-validator.service';
import { AddDiscountCodeDialogComponent } from '../add-discount-code-dialog/add-discount-code-dialog.component';
import { DiscountCodeService } from '@shared/services/administration/discount-code.service';
import { DiscountCode } from '@shared/models/data/DiscountCode';
import { validateHorizontalPosition } from '@angular/cdk/overlay';
import { finalize } from 'rxjs/operators';
import { ApplicationService } from '@shared/services/administration/application.service';
import { Constants } from '@shared/services/constants/constants';

@Component({
  selector: 'app-edit-discount-code',
  templateUrl: './edit-discount-code.component.html',
  styleUrls: ['./edit-discount-code.component.scss']
})
export class EditDiscountCodeComponent implements OnInit {

  formGroup: FormGroup;

  loading = false;
  memberGroupsOptions: string[];
  selectedMemberGroups: string[];
  existingDiscountCode: DiscountCode;



  constructor(
    private fb: FormBuilder,
    private applicationService: ApplicationService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddDiscountCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private discountCodeService: DiscountCodeService,
  ) { }

  ngOnInit() {
    this.existingDiscountCode = this.data.discountCode;
    this.getMemberTypes();

    this.populateFormGroup();
  }

  populateFormGroup() {
    this.formGroup = this.fb.group({
      discountCode: [this.existingDiscountCode.marketCode, [Validators.required, Validators.maxLength(50)]],
      beginDate: [this.existingDiscountCode.effectiveBeginDate, Validators.required],
      endDate: [this.existingDiscountCode.effectiveEndDate, Validators.required],
      description: [this.existingDiscountCode.description],
      flatDiscount: [this.existingDiscountCode.flatDiscount, Validators.max(5000)],
      discountPercent: [this.existingDiscountCode.discountPercent, Validators.max(100)],
      memberGroups: [this.existingDiscountCode.memberGroups.split(', '), Validators.required]
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.loading = true;
    var updatedDiscountCodeRequest = this.mapToDiscountCodeRequest(this.formGroup);
    this.discountCodeService.updateDiscountCode(updatedDiscountCodeRequest).pipe(
      finalize(() => {
        this.loading = false;
      }))
      .subscribe({
        next: () => {
          this.openSnackBar("Successfully updated.")
          this.closeDialog();
        },
        error: (err) => {
          if (err.status === 409) {
            alert("Error in updating. Duplicate code.")
          } else {
            alert("Error in updating.")
          }
        }
      })
  }

  mapToDiscountCodeRequest(formGroup: FormGroup): DiscountCode {
    let discountCodeRequest = new DiscountCode();
    discountCodeRequest.id = this.existingDiscountCode.id;
    discountCodeRequest.description = formGroup.controls['description'].value;
    discountCodeRequest.discountPercent = formGroup.controls['discountPercent'].value;
    discountCodeRequest.flatDiscount = formGroup.controls['flatDiscount'].value;
    discountCodeRequest.effectiveBeginDate = formGroup.controls['beginDate'].value;
    discountCodeRequest.effectiveEndDate = formGroup.controls['endDate'].value;
    discountCodeRequest.marketCode = formGroup.controls['discountCode'].value;
    discountCodeRequest.memberGroups = formGroup.controls['memberGroups'].value;

    return discountCodeRequest;
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "Dismiss", { duration: 2000 });
  }

  getMemberTypes() {
    this.loading = true;
    this.applicationService.getAllMemberApplicationTypes().pipe(
      finalize(() => {
        this.loading = false;
      })).subscribe({
        next: (x) => {
          const codes = Array.from(new Set(x.map(y => y.memberType.code)));
          this.memberGroupsOptions = codes as string[];
        },
        error: () => {
          alert("Error in loading form.")
          this.closeDialog();
        }
      });
  }

}
